export default class TimeSpent {
  public minutesWork = 0;

  public minutesTravel = 0;

  public minutesPause = 0;

  public minutesPassenger = 0;
}
